import React, {Component} from 'react';
import {  Switch, Link, Route } from 'react-router-dom';
import CertificatesContent from '../components/CertificatesContent'; 
 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import { Helmet } from "react-helmet";
import { api_base_url, base_url} from '../common/Constants';
 
class Certificates extends React.Component{
 
    render()
    {
       
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
        return (
            <div className="page-wrapper">
                <Header/> 
                <Helmet>
                    <title>{metas[3].title}</title>  
                    <meta name="description" content={metas[3].meta_description} />
                    <meta name="keywords" content={metas[3].meta_title} />
                    <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
                    <link rel="canonical" href={base_url+'certificates'} />
                </Helmet>
                <PageHeader title="Certificates"/>
                <CertificatesContent content={JSON.parse(localStorage.getItem("content"))} certificates={JSON.parse(localStorage.getItem("certificates"))} />  
                <Footer/>
            </div>
       
        )
    }

}
export default Certificates;